/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Lead } from './Lead';
import {
    LeadFromJSON,
    LeadFromJSONTyped,
    LeadToJSON,
    LeadToJSONTyped,
} from './Lead';

/**
 * 
 * @export
 * @interface LeadsFindAllResponse
 */
export interface LeadsFindAllResponse {
    /**
     * 
     */
    data: Array<Lead>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
    /**
     * User lookup map deduped across the page, keyed by user_id. Each value matches the LeadAssignmentUser shape. Typed as an open object because the openapi-generator's TypeScript template emits broken FromJSON for typed-additionalProperties Records; consumers cast at use site.
     */
    users?: { [key: string]: any; };
}

/**
 * Check if a given object implements the LeadsFindAllResponse interface.
 */
export function instanceOfLeadsFindAllResponse(value: object): value is LeadsFindAllResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function LeadsFindAllResponseFromJSON(json: any): LeadsFindAllResponse {
    return LeadsFindAllResponseFromJSONTyped(json, false);
}

export function LeadsFindAllResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadsFindAllResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(LeadFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
        'users': json['users'] == null ? undefined : json['users'],
    };
}

export function LeadsFindAllResponseToJSON(json: any): LeadsFindAllResponse {
    return LeadsFindAllResponseToJSONTyped(json, false);
}

export function LeadsFindAllResponseToJSONTyped(value?: LeadsFindAllResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(LeadToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
        'users': value['users'],
    };
}

